import { Component, Input } from '@angular/core';

@Component({
  selector: 'skeleton-loading-field',
  templateUrl: './skeleton-loading-field.component.html',
})
export class SkeletonLoadingFieldComponent {
  @Input() variant: 'input' | 'textarea' = 'input';
}
